import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import HeaderTop from '../../components/HeaderTop/HeaderTop';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle';
import ServiceSection from '../../components/ServiceSection/ServiceSection';
import SubscribeSectionS2 from '../../components/SubscribeSectionS2/SubscribeSectionS2';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/full_logo.png';

const ServicePage = () => {
    const { t } = useTranslation();

    return (
        <Fragment>
            <HeaderTop />
            <Navbar hclass={'wpo-site-header'} Logo={Logo} />
            <PageTitle pageTitle={t('pages.services')} pagesub={t('pages.services')} />
            <ServiceSection hclass={'wpo-service-area section-padding'} ServiceBtn={true} />
            <SubscribeSectionS2 />
            <Footer hclass={'wpo-site-footer-s3'} NewsletterShow={false} InstagramShow={true} FooterShape={false} />
            <Scrollbar />
        </Fragment>
    );
};

export default ServicePage;
